import { render, staticRenderFns } from "./ProposteSoggiorno.vue?vue&type=template&id=7f286a1b"
import script from "./ProposteSoggiorno.vue?vue&type=script&lang=js"
export * from "./ProposteSoggiorno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports